// src/components/FD/LuckyDraw.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import '../GL/LoanPayment.css';

const LuckyDraw = () => {
  const [formData, setFormData] = useState({
    registration_no: '',
    month: '',
    rd_winner: ''
  });
  const [winners, setWinners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // Set default month to current month
    const today = new Date();
    const defaultMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
    setFormData(prev => ({ ...prev, month: defaultMonth }));
    fetchWinners();
  }, []);

  const fetchWinners = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/fd/lucky-winners`);
      setWinners(response.data);
    } catch (error) {
      console.error('Error fetching lucky winners:', error);
      alert('Failed to load lucky winners');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: value 
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.registration_no || !formData.month) {
      alert('Please fill required fields (Registration No and Month)');
      return;
    }

    if (!window.confirm(`Add ${formData.registration_no} as lucky winner for ${formData.month}?`)) {
      return;
    }

    try {
      setSubmitting(true);
      await axios.post(`${API_BASE_URL}/api/fd/lucky-draw`, formData);
      alert('Lucky winner added successfully!');
      setFormData({
        registration_no: '',
        month: formData.month, // Keep the month
        rd_winner: ''
      });
      fetchWinners();
    } catch (error) {
      console.error('Error adding lucky winner:', error);
      alert(error.response?.data?.error || 'Failed to add lucky winner');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="loan-payment-container">
      <div className="loan-payment-form">
        <h1>Lucky Draw</h1>
        
        <form onSubmit={handleSubmit} style={{ marginBottom: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '15px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Registration No: *</label>
              <input
                type="text"
                name="registration_no"
                value={formData.registration_no}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
                placeholder="e.g., RD001"
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Month: *</label>
              <input
                type="month"
                name="month"
                value={formData.month}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>RD Winner:</label>
              <input
                type="text"
                name="rd_winner"
                value={formData.rd_winner}
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
                placeholder="Enter RD winner text"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={submitting}
            style={{
              padding: '10px 20px',
              backgroundColor: '#f39c12',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: submitting ? 'not-allowed' : 'pointer',
              opacity: submitting ? 0.6 : 1,
              fontWeight: 'bold'
            }}
          >
            {submitting ? 'Adding...' : 'Add Lucky Winner'}
          </button>
        </form>

        <h2 style={{ marginBottom: '15px' }}>Lucky Winners List</h2>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>
        ) : winners.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <p>No lucky winners found.</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Registration No</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Name</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Month</th>
                  <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>RD Winner</th>
                </tr>
              </thead>
              <tbody>
                {winners.map((winner) => (
                  <tr key={winner.id}>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{winner.registration_no}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{winner.name}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>{winner.month}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd' }}>{winner.rd_winner || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default LuckyDraw;

